import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/notice/getList',
    method: 'get',
    params
  })
}

export function getUnReadList() {
  return request({
    url: '/notice/unReadList',
    method: 'get'
  })
}

export function getInfo(params) {
  return request({
    url: '/notice/info',
    method: 'get',
    params
  })
}

export function getData(data, url) {
  return request({
    url: url,
    method: 'post',
    data
  })
}
